<ng-container *ngIf="!showForm">
  <table mat-table [dataSource]="model.value" class="mat-elevation" data-test="gsm-ggk_table">
    <!-- art Column -->
    <ng-container matColumnDef="art">
      <th mat-header-cell *matHeaderCellDef>Art</th>
      <td mat-cell *matCellDef="let element">{{ element.status === 'E' ? element.art : 'Wird nachgebracht' }}</td>
    </ng-container>

    <!-- marke Column -->
    <ng-container matColumnDef="marke">
      <th mat-header-cell *matHeaderCellDef>Marke</th>
      <td mat-cell *matCellDef="let element">{{ element.marke }}</td>
    </ng-container>

    <!-- baujahr Column -->
    <ng-container matColumnDef="baujahr">
      <th mat-header-cell *matHeaderCellDef>Baujahr</th>
      <td mat-cell *matCellDef="let element">{{ element.baujahr }}</td>
    </ng-container>

    <!-- anschaffungspreis Column -->
    <ng-container matColumnDef="anschaffungspreis">
      <th mat-header-cell *matHeaderCellDef>Anschaffungspreis</th>
      <td mat-cell *matCellDef="let element">
        {{ element.anschaffungspreis && '€ ' }}{{ element.anschaffungspreis | number: '1.2-2':'de-DE' }}
      </td>
    </ng-container>

    <!-- dokument Column -->
    <ng-container matColumnDef="dokument">
      <th mat-header-cell *matHeaderCellDef>Dokument</th>
      <td mat-cell *matCellDef="let element" class="filename">
        {{ element.fileList && element.fileList[0]?.originalFileName }}
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Aktionen</th>
      <td mat-cell *matCellDef="let element; let index = index">
        <button mat-icon-button (click)="editItem(element, index)" data-test="gsm-ggk_edit">
          <mat-icon>{{ model.disabled ? 'visibility' : 'edit' }}</mat-icon>
        </button>
        <button
          mat-icon-button
          *ngIf="!model.disabled && !model.additional?.updateClaim"
          (click)="removeItem(index)"
          data-test="gsm-ggk_delete"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['art', 'marke', 'baujahr', 'anschaffungspreis', 'dokument', 'actions']"></tr>
    <tr mat-row
        *matRowDef="let row; columns: ['art', 'marke', 'baujahr', 'anschaffungspreis', 'dokument', 'actions']"></tr>
  </table>
</ng-container>
<div
  class="add-item"
  *ngIf="(!showForm && !model.disabled && !model.additional?.updateClaim) || (!model.value.length && model.additional?.updateClaim)"
  (click)="setForm(null)"
  data-test="gsm-ggk_add"
>
  <button mat-mini-fab color="primary">
    <mat-icon>add</mat-icon>
  </button>
  <span class="label">Gerät/Sache hinzufügen</span>
</div>
<form *ngIf="showForm" [formGroup]="entryFormGroup">
  <mat-card class="add-geraet-card">
    <dynamic-material-form
      [group]="entryFormGroup"
      [model]="entryFormModel"
      (matEvent)="onCustomEvent($event, null, true)"
      data-test="gsm-ggk_entry-form"
    ></dynamic-material-form>
    <button mat-raised-button class="cancel-button" (click)="cancelEdit()" data-test="gsm-ggk_cancel-btn">
      {{ model.disabled ? 'Schließen' : 'Abbrechen' }}
    </button>
    <button
      mat-raised-button
      color="primary"
      class="gsm-ggk_save-btn"
      *ngIf="!model.disabled"
      [disabled]="!isEntryFormValid || isSaving"
      (click)="saveItem($event)"
      data-test="gsm-ggk_save-btn"
    >
      Speichern
    </button>
  </mat-card>
</form>
